import { Directive, ElementRef, Input, Renderer2, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[spsChildrenMenuToggler]'
})
export class ChildrenMenuToggler implements OnChanges {

  @Input() spsChildrenMenuToggler!: boolean; // true = open, false = closed
  private duration = '300ms ease-in-out'; // duration of the animation (open/close)

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.setStyle(this.el.nativeElement, 'overflow', 'hidden');
    this.renderer.setStyle(this.el.nativeElement, 'transition', `height ${this.duration}`);
  }

  /**
   * listening on changes
   * if parent active state changed then the
   * child list height chang will be animated
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['spsChildrenMenuToggler']) {
      this.toggleHeight();
    }
  }

  /**
   * toggle the height of children container to force the animation
   * @private
   */
  private toggleHeight(): void {
    const element = this.el.nativeElement;
    if (this.spsChildrenMenuToggler) {
      /** open element: set height to "auto" to calculate the real height */
      this.renderer.setStyle(element, 'height', 'auto');
      const autoHeight = `${element.scrollHeight}px`;
      /** set height to 0px to force the transition */
      this.renderer.setStyle(element, 'height', '0px');
      /** start the animation */
      setTimeout(() => {
        this.renderer.setStyle(element, 'height', autoHeight);
      },10);
    } else {
      /** close the element: set height to scrollheight then to 0px to force animation */
      this.renderer.setStyle(element, 'height', `${element.scrollHeight}px`);
      setTimeout(() => {
        this.renderer.setStyle(element, 'height', '0px');
      },10);
    }
  }
}
